const graphConfig = {
  YAxisWidth: 60,
  XAxisHeight: 30,
  tickMargin: -2,
  dx: 8, // dx: moves YTick labels left
  dy: 2, // dy: moves XTick labels down
  axisFontsize: "14px",
  yTickCount: 5,
  strokeWidth: 2,
  gridStrokeWidth: 1,
  areaFillColorOpacity: 0.3,
  marginTop: 10,
  marginLeft: 18,
  marginRight: 36,
  marginBottom: 0,
};

export default graphConfig;
